/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ComplaintReasonVisibleType = 'Internal' | 'External' | 'Both';

export const ComplaintReasonVisibleType = {
    Internal: 'Internal' as ComplaintReasonVisibleType,
    External: 'External' as ComplaintReasonVisibleType,
    Both: 'Both' as ComplaintReasonVisibleType
};

